import Logger from "logger/logger"
import {useRef} from "react"

export function useDebounce() {
  const timeout = useRef<any>(null)
  const rateLimitRef = useRef<number>(0)

  function debounce(callback: () => any, time: number, rateLimit?: number) {
    if (timeout.current) {
      clearTimeout(timeout.current)
      timeout.current = null
    }
    if (rateLimitRef.current === rateLimit) {
      Logger('warn.useDebounce.rateLimit.reached', callback.name)
      return
    }
    rateLimitRef.current++
    timeout.current = setTimeout(() => {
      callback()
    }, time)
  }

  return {
    debounce,
  }
}
